import { render } from "./icon-times.vue?vue&type=template&id=633396b1"
import script from "./icon-times.vue?vue&type=script&lang=js"
export * from "./icon-times.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__